import { ServiceConfig } from '@user/store/services/config'

export const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.activityTypes.activityTypes}`
